import * as stylex from '@stylexjs/stylex';
import { Link } from 'react-router-dom';
import { headerStyles as styles } from '@/header/header.styles';
import { getFolderLink, getWorkbooksLink } from '@/main/routing.utilities';
import { translateBreadcrumb } from '@/utilities/homescreen.utilities';
import type { WorkbookItemPreview } from '@/workbook/workbook.constants';

interface HeaderBreadcrumbsProps {
  breadcrumbs: WorkbookItemPreview[];
  isWorksheetDisplayed: boolean;
}

export const HeaderBreadcrumbs = ({ breadcrumbs, isWorksheetDisplayed }: HeaderBreadcrumbsProps) => {
  const getLink = (crumb: WorkbookItemPreview) =>
    crumb.id && !crumb.tabHash ? getFolderLink(crumb.id) : getWorkbooksLink(crumb.tabHash);

  return (
    <div {...stylex.props(styles.breadcrumbWrapper)}>
      {!!breadcrumbs.length && isWorksheetDisplayed && (
        <nav aria-label="Breadcrumb" {...stylex.props(styles.breadcrumbText)}>
          <ul data-testid="headerBreadcrumbs" {...stylex.props(styles.breadcrumbList)}>
            {breadcrumbs.map((crumb) => (
              <li key={`crumbId_${crumb.id}`} {...stylex.props(styles.breadcrumbItem)}>
                <Link to={getLink(crumb)} {...stylex.props(styles.breadcrumbLink)}>
                  {translateBreadcrumb(crumb)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  );
};
